import { createApiSlice } from "@common";
import { MY_INFO_RELATIONSHIP_CONFIG } from "@routes";

const apiConfig = [
  {
    name: "addEmployeeRelationshipType",
    method: "post",
    url: MY_INFO_RELATIONSHIP_CONFIG,
    stateKey: "message",
  },

  {
    name: "getEmployeeRelationshipType",
    method: "get",
    url: MY_INFO_RELATIONSHIP_CONFIG,
    stateKey: "data",
  },

  {
    name: "updateEmployeeRelationshipType",
    method: "put",
    url: MY_INFO_RELATIONSHIP_CONFIG,
    stateKey: "message",
  },

  {
    name: "deleteEmployeeRelationshipType",
    method: "delete",
    url: MY_INFO_RELATIONSHIP_CONFIG,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice("engagementLevel", apiConfig, customReducers);
const engagementLevelSlice = slice;

export default engagementLevelSlice.reducer;

export const {
  addEmployeeRelationshipType,
  getEmployeeRelationshipType,
  updateEmployeeRelationshipType,
  deleteEmployeeRelationshipType,
} = thunks;

export const { rowSelect } = actions;
